export let ENV_NAME;

(function (ENV_NAME) {
  ENV_NAME["PRODUCTION"] = "production";
  ENV_NAME["UAT"] = "uat";
  ENV_NAME["STAGING"] = "staging";
  ENV_NAME["TEST"] = "test";
})(ENV_NAME || (ENV_NAME = {}));

export const LS_CONFIGS_KEY = 'ls_configs';
export let ChainProvider;

(function (ChainProvider) {
  ChainProvider["BSC_MAIN"] = "https://bsc-dataseed.binance.org";
  ChainProvider["BSC_TEST"] = "https://data-seed-prebsc-2-s1.binance.org:8545";
})(ChainProvider || (ChainProvider = {}));

export let ThetanChainId;

(function (ThetanChainId) {
  ThetanChainId["MAIN"] = "0x38";
  ThetanChainId["TEST"] = "0x61";
})(ThetanChainId || (ThetanChainId = {}));